import Component from 'components/content/sections/infoBox/component';

Component.defaultProps = {};
export default Component;
